import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'

import { OVERFLOW_MENU_SOURCE, type OverflowMenuItem, type OverflowMenuSource } from '../responsive-content/responsive-overflow-menu-source'

@Component({
	selector: 'app-expand-collapse-menu',
	imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
	templateUrl: './expand-collapse-menu.html',
	styleUrl: './expand-collapse-menu.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{ provide: OVERFLOW_MENU_SOURCE, useExisting: ExpandCollapseMenu },
	],
})
export class ExpandCollapseMenu implements OverflowMenuSource {
	readonly showExpand = input(false, { alias: 'show-expand', transform: booleanAttribute })
	readonly showCollapse = input(false, { alias: 'show-collapse', transform: booleanAttribute })

	readonly expandAll = output<void>({ alias: 'expand-all' })
	readonly collapseAll = output<void>({ alias: 'collapse-all' })

	readonly showMenu = computed(() => this.showExpand() && this.showCollapse())

	readonly menuLabel = computed(() => {
		if (this.showMenu()) return 'Expand/Collapse'
		if (this.showExpand()) return 'Expand All Groups'
		return 'Collapse All Groups'
	})

	readonly menuIcon = computed(() => {
		if (!this.showMenu() && this.showCollapse()) return 'unfold_less'
		return 'unfold_more'
	})

	readonly menuItems = computed(() => {
		const items: OverflowMenuItem[] = []
		if (this.showExpand()) {
			items.push({ label: 'Expand All Groups', icon: 'unfold_more', run: () => this.expandAll.emit() })
		}
		if (this.showCollapse()) {
			items.push({ label: 'Collapse All Groups', icon: 'unfold_less', run: () => this.collapseAll.emit() })
		}
		return items
	})

}

